/*--------------------------------------
            POPUP
 --------------------------------------*/
Popup = {
  init: function () {
    var res = getCookie("ssll-popup");
    if(res == "1"){

    }else{
      setTimeout(function () {
        $(".popup").addClass("popup-active");
      }, 1000);
    }

    $(".popup__content--close").click(function () {
      $(".popup").removeClass("popup-active");
      setCookie("ssll-popup", 1, 1);
    });

    $("body").click(function (event) {
      if (!$(event.target).closest('.popup__content').length) {
        $(".popup").removeClass("popup-active");
        setCookie("ssll-popup", 1, 1);
      }
  });

  }
};

HeaderBarTop = {
  init: function () {
    var res = getCookie("ssll-headerbar");
    if (res == "1") {
     
    }else{
      setTimeout(function () {
        $(".header-banner").addClass("open");
        $("body").addClass("announcement-bar-open");
      }, 40);
    }
    $(".header-banner__close-btn").click(function () {
      $(".header-banner").removeClass("open");
      $("body").removeClass("announcement-bar-open");
      setCookie("ssll-headerbar", 1, 1);
    });
  }
};


function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60  * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}



$(function () {
  Popup.init();
  HeaderBarTop.init();
});